import { translate } from '@vestahealthcare/common/i18n';

import { EmployeeParams } from 'dash/src/services/EmployeeServices';

export type KeyGetEmployeeParams = keyof EmployeeParams;

export const EMPLOYEE_TABS_LIST = 'employee-page-tab-list';
export const EMPLOYEE_TABS_OVERVIEW = 'employee-page-tab-overview';
export const EMPLOYEE_TABS_LICENSE_DETAILS =
  'employee-page-tab-license-details';
export const EMPLOYEE_TABS = [
  {
    label: translate('employees.tabs.list'),
    value: EMPLOYEE_TABS_LIST,
  },
  {
    label: translate('employees.tabs.licenseOverview'),
    value: EMPLOYEE_TABS_OVERVIEW,
  },
  {
    label: translate('employees.tabs.licenseDetails'),
    value: EMPLOYEE_TABS_LICENSE_DETAILS,
  },
];
